export default __webpack_public_path__ + "static/media/dynamic-fund-coffee-mobbanner.eb5c0684.jpg";